import type { DateFormat, Locale } from "@porsche-customer/slfinrtl-context-types"
import { countryDateFormats, isCountry, isLocale } from "@porsche-customer/slfinrtl-context-types"
import { useMemo } from "react"
import { getJwtPayload } from "src/common/jwt/jwtUtils"

interface DateSettings {
	dateFormat: DateFormat
	locale: Locale
}

// Screens outside of a dealership (e.g. news, dealership list) have no dealer context providing these settings
export const useDateSettingsOutsideDealership = (): DateSettings =>
	useMemo(() => {
		const country = getJwtPayload()?.["ppn:country"]
		const { language } = window.navigator

		return {
			dateFormat: isCountry(country) ? countryDateFormats[country] : "yyyy-MM-dd",
			locale: isLocale(language) ? language : "en-US",
		}
	}, [])
